import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSign, CONTROL_MODAL, BLOCKCHAIN_MODAL } from 'context/signview';
import { Modal, ModalFooter, ModalBody, ModalHeader, ButtonGroup } from 'reactstrap';

export default function Blockchain() {

    const { t } = useTranslation();

    const [{ modal, contract }, dispatch] = useSign();

    const { documentId, name, _id, blockchain: { txid, hash } = {} } = contract;

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: BLOCKCHAIN_MODAL })
    }

    return (
        <Modal isOpen={modal.includes(BLOCKCHAIN_MODAL)} size="fs">
            <ModalHeader className=" bg-mix" toggle={handleClose}>
                <div className="container">
                    <h1 className="">{t('blockchain.title')}</h1>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="card card-title shadow-sm">
                                <div className="card-body p-4">
                                    <h5 className="font-weight-bold">{t('sign.blockchain.register_success')}</h5>
                                    <p className="text-muted font-weight-thin">{t('sign.blockchain.register_success_desc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="card card-title shadow-sm">
                                <div className="card-body p-4">
                                    <h5 className="font-weight-bold">{t('sign.blockchain.register_success')}</h5>
                                    <p className="text-muted font-weight-thin"> {t('contracts.constants.name')}: {documentId} - {name}</p>
                                    <p className="text-muted font-weight-thin"> Id: {_id}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="bg-grey">
                <div className="container">
                    <h4 className="font-weight-bold mb-3">{t('sign.blockchain.process_title')}</h4>
                    <div className="row">
                        <div className="col-lg-3 col-md-3 my-3">
                            <div className="card border-0 shadow-sm rounded p-4 process-step">
                                <div className="row d-flex mb-3">
                                    <div className="col-lg-6">
                                        <img src="/images/blockchain-icon-1.svg" className="img-fluid blockchain-img" alt="blockchain-img" />
                                    </div>
                                    <div className="col-lg-6 align-self-center">
                                        <h2 className="lead font-weight-bold my-0">{t('common.step')} 1</h2>
                                        <small className="text-success"><i className="fas fa-check-circle mr-2 mb-0"></i> {t('blockchain.completed')}</small>
                                    </div>
                                </div>
                                <h4 className="align-self-center font-weight-bold m-3">{t('sign.blockchain.process_hashing_title')}</h4>
                                <p className="text-muted mb-3">{t('sign.blockchain.process_hashing_description')}</p>
                                <p className="text-muted">{t('sign.blockchain.process_hashing_hash')}</p>
                                <span className="badge badge-primary-50 font-weight-thin w-100 font-weight-thin overflow-auto">{hash}</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 my-3">
                            <div className="card border-0 shadow-sm rounded p-4 process-step">
                                <div className="row d-flex mb-3">
                                    <div className="col-lg-6">
                                        <img src="/images/blockchain-icon-2.svg" className="img-fluid blockchain-img" alt="blockchain-img" />
                                    </div>
                                    <div className="col-lg-6 align-self-center">
                                        <h2 className="lead font-weight-bold my-0">{t('common.step')} 2</h2>
                                        <small className={clsx(txid ? 'text-success' : 'text-warning')}><i className="fas fa-circle mr-2 mb-0"></i> {txid ? 'Completado' : 'Pendiente'}</small>
                                    </div>
                                </div>
                                <h4 className="align-self-center font-weight-bold m-3">{t('blockchain.register')}</h4>
                                <p className="text-muted mb-0">{t('sign.blockchain.process_register_description')}</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 my-3">
                            <div className="card border-0 shadow-sm rounded p-4 process-step">
                                <div className="row d-flex mb-3">
                                    <div className="col-lg-6">
                                        <img src="/images/blockchain-icon-3.svg" className="img-fluid blockchain-img" alt="blockchain-icon" />
                                    </div>
                                    <div className="col-lg-6 align-self-center">
                                        <h2 className="lead font-weight-bold my-0">{t('common.step')} 3</h2>
                                        <small className={clsx(txid ? 'text-success' : 'text-warning')}><i className="fas fa-circle mr-2 mb-0"></i> {txid ? 'Completado' : 'Pendiente'}</small >
                                    </div>
                                </div>
                                <h4 className="align-self-center font-weight-bold m-3">{t('sign.blockchain.process_verify_title')}</h4>
                                {txid ? <>
                                    <p className="text-muted">{t('sign.blockchain.process_verify_description_stamped')}:</p>
                                    <span className="badge badge-primary-50 w-100 d-inline-block mb-3 font-weight-thin overflow-auto">{txid}</span>
                                </> :
                                    <p className="text-muted">{t('sign.blockchain.process_verify_description_generate')}</p>
                                }

                                <p className="text-muted mb-0">{t('sign.blockchain.process_verify_description')}</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 my-3">
                            <div className="card border-0 shadow-sm rounded p-4 process-step">
                                <div className="row d-flex mb-3">
                                    <div className="col-lg-6">
                                        <img src="/images/blockchain-icon-4.svg" className="img-fluid blockchain-img" alt="blockchain-icon" />
                                    </div>
                                    <div className="col-lg-6 align-self-center">
                                        <h2 className="lead font-weight-bold my-0">{t('common.step')} 4</h2>
                                        <small className={clsx(txid ? 'text-success' : 'text-warning')}><i className="fas fa-circle mr-2 mb-0"></i> {txid ? 'Completado' : 'Pendiente'}</small >
                                    </div>
                                </div>
                                <h4 className="align-self-center font-weight-bold m-3">{t('contracts.new.security_title')}</h4>
                                <p className="text-muted mb-3">{t('sign.blockchain.process_security_description')}</p>
                                <a href="https://verify.originstamp.com/" rel="noopener noreferrer" target="_blank" className={clsx('btn btn-primary w-100', txid || 'disabled')}>{t('sign.blockchain.verify')}</a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 col-md-12">
                            <h4 className="font-weight-bold mb-3">{t('sign.blockchain.verify_title')}</h4>
                            <p className="text-muted">{t('sign.blockchain.verify_seed')}</p>
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <button className="btn btn-sm btn-primary" onClick={handleClose}>{t('common.close')}</button>
                </ButtonGroup>
            </ModalFooter>
        </Modal >
    )

}